import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

import { showErrorToast, showSuccessToast } from "#app/notifications";
import { processStepCatalogQuery } from "#modules/quoteRequestLines/infra/processStepCatalogQuery";

import { customSurfaceTreatmentsQuery } from "../infra/customSurfaceTreatments.query";
import { uploadCustomSurfaceTreatments } from "../infra/uploadCustomSurfaceTreatments.api";

export const useUploadCustomSurfaceTreatments = () => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  const { mutate, ...rest } = useMutation({
    mutationFn: ({ companyId, file }: { companyId: string; file: File }) =>
      uploadCustomSurfaceTreatments(companyId, file),

    onSuccess: (_, variables) => {
      void queryClient.invalidateQueries(customSurfaceTreatmentsQuery(variables.companyId));
      void queryClient.invalidateQueries(processStepCatalogQuery());

      showSuccessToast({
        title: t("settings.surfaceTreatments.upload.successMessage"),
      });
    },
    onError: (err: Error) => {
      showErrorToast({ title: err.message });
    },
  });

  return { uploadCustomSurfaceTreatments: mutate, ...rest };
};
